<template>
  <main>
    <!-- Yang -->
    <!-- 常见问题介绍 -->
    <div class="page-area">
      <div class="breadcumb-overlay"></div>
      <div class="container">
        <div class="row">
          <!-- 常见问题img -->
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="breadcrumb text-center">
              <div class="section-headline white-headline">
                <!-- @click="Jump_center" -->
                <h3>常见问题解答</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="PT_F">
      <div class="ProblemSet_title problemSet_all">你需要什么帮助?</div>
    </div>-->
    <div class="ProblemSet">
      <div class="problemSet_all">
        <router-link :to="{ path: `/Account` }">
          <div class="problemSetA_div">
            <div class="prSAD_icon">
              <svg
                width="3em"
                height="3em"
                viewBox="0 0 16 16"
                class="bi bi-file-person-fill"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-1 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 4c2.623 0 4.146.826 5 1.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.245C3.854 11.825 5.377 11 8 11z"
                />
              </svg>
              <br />
              <span class="prSADI_span">账户常见问题</span>
            </div>
          </div>
        </router-link>
        <router-link :to="{ path: `/GameProblem` }">
          <div class="problemSetA_div">
            <div class="prSAD_icon">
              <svg
                width="3em"
                height="3em"
                viewBox="0 0 16 16"
                class="bi bi-controller"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M11.119 2.693c.904.19 1.75.495 2.235.98.407.408.779 1.05 1.094 1.772.32.733.599 1.591.805 2.466.206.875.34 1.78.364 2.606.024.815-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773a11.307 11.307 0 0 1-.739-.809c-.126-.147-.25-.291-.368-.422-.728-.804-1.597-1.527-3.224-1.527-1.627 0-2.496.723-3.224 1.527-.119.131-.242.275-.368.422-.243.283-.494.576-.739.81-.398.378-.877.705-1.513.772a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772.486-.485 1.331-.79 2.235-.98.932-.196 2.03-.292 3.119-.292 1.089 0 2.187.096 3.119.292zm-6.032.979c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a13.748 13.748 0 0 0-.748 2.295 12.351 12.351 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.505C4.861 9.97 5.978 9.026 8 9.026s3.139.943 3.965 1.855c.164.182.307.35.44.505.214.25.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.354 12.354 0 0 0-.339-2.406 13.753 13.753 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27-1.036 0-2.063.091-2.913.27z"
                />
                <path
                  d="M11.5 6.026a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-7-2.5h1v3h-1v-3z"
                />
                <path
                  d="M3.5 6.526h3v1h-3v-1zM3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .258.966l-1.932.518a.5.5 0 0 1-.612-.354zm9.976 0a.5.5 0 0 0-.353-.613l-1.932-.518a.5.5 0 1 0-.259.966l1.932.518a.5.5 0 0 0 .612-.354z"
                />
              </svg>
              <br />

              <span class="prSADI_span">游戏</span>
            </div>
          </div>
        </router-link>
        <router-link :to="{ path: `/Pay` }">
          <div class="problemSetA_div">
            <div class="prSAD_icon">
              <svg
                width="3em"
                height="3em"
                viewBox="0 0 16 16"
                class="bi bi-credit-card-fill"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0V4z" />
                <path
                  fill-rule="evenodd"
                  d="M0 7v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7H0zm3 2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H3z"
                />
              </svg>
              <br />
              <span class="prSADI_span">支付问题</span>
            </div>
          </div>
        </router-link>
        <router-link :to="{ path: `/activity` }">
          <div class="problemSetA_div">
            <div class="prSAD_icon">
              <svg
                width="3em"
                height="3em"
                viewBox="0 0 16 16"
                class="bi bi-bell-fill"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"
                />
              </svg>
              <br />
              <span class="prSADI_span">活动</span>
            </div>
          </div>
        </router-link>
        <!-- <router-link :to="{ path: `/Maiboxes` }">
          <div class="problemSetA_div">
            <div class="prSAD_icon">
              <svg
                width="3em"
                height="3em"
                viewBox="0 0 16 16"
                class="bi bi-envelope-fill"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"
                />
              </svg>
              <br />
              <span class="prSADI_span">Maiboxes</span>
            </div>
          </div>
        </router-link>-->
        <router-link :to="{ path: `/Safety` }">
          <div class="problemSetA_div">
            <div class="prSAD_icon">
              <svg
                width="3em"
                height="3em"
                viewBox="0 0 16 16"
                class="bi bi-lock-fill"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 9a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V9z"
                />
                <path
                  fill-rule="evenodd"
                  d="M4.5 4a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"
                />
              </svg>
              <br />
              <span class="prSADI_span">安全问题</span>
            </div>
          </div>
        </router-link>
        <!-- <router-link :to="{ path: `/Community` }">
          <div class="problemSetA_div">
            <div class="prSAD_icon">
              <svg
                width="3em"
                height="3em"
                viewBox="0 0 16 16"
                class="bi bi-chat-left-dots-fill"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm5 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                />
              </svg>
              <br />
              <span class="prSADI_span">社区</span>
            </div>
          </div>
        </router-link>-->
        <router-link :to="{ path: `/Client` }">
          <div class="problemSetA_div">
            <div class="prSAD_icon">
              <svg
                width="3em"
                height="3em"
                viewBox="0 0 16 16"
                class="bi bi-laptop"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M13.5 3h-11a.5.5 0 0 0-.5.5V11h12V3.5a.5.5 0 0 0-.5-.5zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11z"
                />
                <path
                  d="M0 12h16v.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5V12z"
                />
              </svg>
              <br />
              <span class="prSADI_span">客户端问题</span>
            </div>
          </div>
        </router-link>
        <div class="problemSetA_div PLSAD"></div>
        <div class="problemSetA_div PLSAD"></div>
        <div class="problemSetA_div PLSAD"></div>
      </div>
    </div>
    <section class="GameProblem">
      <router-view></router-view>
    </section>
    <!-- End FAQ -->
    <!-- 全局qq和微信联系方式 index中有全局 -->
    <div class="hotline">
      <i class="fa fa-qq link"></i>
      <div class="qrcode-div">
        <img
          draggable="false"
          style="width: 100%; height: 100%"
          class="image"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/qqCode.png`"
        />
      </div>
    </div>
    <div class="hotline2">
      <i class="fa fa-wechat link-wechat"></i>
      <div class="qrcode-div2">
        <img
          class="image"
          draggable="false"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/Wechat2.jpg`"
        />
      </div>
    </div>
  </main>
</template>

<script>
import gzh from '@/assets/gzh.png'
export default {
  metaInfo: {
    title: '海星云-常见问题-云电脑使用问题解答',
    meta: [
      {
        name: 'keywords',
        content: '常见问题,游戏问题,云电脑出现的问题,解决方法'
      },
      {
        name: 'description',
        content: '海星云帮您解决使用云电脑时常见问题，了解如何使用云电脑玩游戏常见问题的玩家，海星云是支持全平台畅玩，平板、手机、电视、PC、应有尽有！'
      }
    ]
  },
  data () {
    return {
      gzh: gzh
    }
  },
  methods: {
    // Jump_center(){
    //   this.$router.push({
    //     path:'./Center',
    //     query:{value:'nice'}
    //   })
    // }
  },
  mounted () {}
}
</script>
<style lang="scss" scoped>
.panel-collapse img {
  width: 150px;
  height: 150px;
}
.panel-body .s {
  font-size: 12px;
}
.PT_F {
  background: #100e2e;
}
.ProblemSet_title {
  padding-top: 140px;
  text-align: center;
  height: 120px !important;
  color: white !important;
  font-size: 20px;
}
.ProblemSet {
  background-color: #100e2e;
  padding-top: 35px;
  padding-bottom: 50px;
}
.problemSet_all {
  width: 1170px;
  height: 350px;
  margin: 80px auto 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  transition-duration: 0.2s;
  align-items: center;
}
.problemSetA_div {
  width: 255px;
  height: 155px;
  cursor: pointer;
  transition-duration: 0.3s;
  padding-left: 62.5px;
  padding-top: 12.5px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.05);
  border-top: 3px solid #3a4048;
}
.problemSetA_div:hover {
  background-color: #ffc107;
  border-color: #ffc107;
  background-color: rgba(255, 255, 255, 0.1);
}
.problemSetA_div:hover .bi {
  color: #ffc107;
}
.problemSetA_div:hover .prSADI_span {
  color: #ffc107;
  transition-duration: 0.2s;
  text-align: center;
}
.prSADI_span {
  color: white;
}
.PLSAD {
  opacity: 0;
}
@media screen and(min-width:1450px) {
  .problemSet_all {
    width: 1075px;
    height: 550px;
  }
  .problemSetA_div {
    width: 250px;
    height: 150px;
    padding-left: 60px;
    padding-top: 10px;
  }
  .PLSAD {
    opacity: 0;
  }
}
// @media screen and (min-width: 960px) and (max-width: 1199px) {
@media screen and(min-width: 1050px) and (max-width: 1450px) {
  .problemSet_all {
    width: 850px;
    height: 450px;
  }
  .problemSetA_div {
    width: 205px;
    height: 130px;
    padding-left: 37.5px;
    padding-top: 0px;
  }
  .PLSAD {
    opacity: 0;
  }
}
@media screen and(min-width:920px) and (max-width: 1050px) {
  .problemSet_all {
    width: 750px;
    height: 409px;
  }
  .problemSetA_div {
    width: 220px;
    height: 130px;
    padding-left: 45px;
    padding-top: 0px;
  }
  .PLSAD {
    opacity: 0;
  }
}
@media screen and(min-width:760px) and (max-width: 920px) {
  .problemSet_all {
    width: 560px;
    height: 409px;
  }
  .problemSetA_div {
    width: 180px;
    height: 130px;
    padding-left: 25px;
    padding-top: 0px;
  }
  .PLSAD {
    opacity: 0;
  }
}
@media screen and(min-width:500px) and (max-width: 760px) {
  .problemSet_all {
    width: 450px;
    height: 840px;
  }
  .problemSetA_div {
    width: 210px;
    height: 200px;
    padding-left: 40px;
    padding-top: 35px;
  }
  .PLSAD {
    opacity: 0;
    display: none;
  }
}
@media screen and(min-width:320px) and (max-width: 500px) {
  .problemSet_all {
    width: 320px;
    height: 600px;
  }
  .problemSetA_div {
    width: 155px;
    height: 145px;
    padding-left: 12.5px;
    padding-top: 7.5px;
  }
  .PLSAD {
    opacity: 0;
    display: none;
  }
}
.prSAD_icon {
  width: 130px;
  height: 130px;
  text-align: center;
  color: white;
}
.bi {
  margin-top: 14%;
  transition-duration: 0.2s;
}

//解答问题具体跳转界面设置
.GameProblem {
  position: fixed;
  left: 0;
  top: 0px;
  background-color: #100e2e;
  z-index: 10;
  padding-top: 115px;
  height: 100%;
}
@media screen and(min-width:767px) and (max-width: 1200px) {
  .GameProblem {
    padding-top: 180px;
  }
}
@media screen and(max-width:767px) {
  .GameProblem {
    padding-top: 66px;
  }
}
@media screen and (max-width: 1000px) {
  .ProblemSet_title {
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/faq.vue